import message from '@/utils/message';

/**
 * Bytrack 在线客服入口占位：脚本未落地前不误开 Tawk。
 * 落地后在此注入 SDK 并 maximize。
 */
export function openBytrackChat() {
  // eslint-disable-next-line no-console
  console.info('[support-livechat] openBytrackChat: bytrack sdk not ready');
  message.info('客服加载中');
}
